import {
  backgroundSkinParams,
  cssPropertyToDefaultValueMap,
  generateDefaultStyleProperties,
  generateSkinDefaults,
  withPrefixes,
} from '@wix/editor-elements-panel';
import type {
  PropDefinition,
  SkinDefinition,
} from '@wix/editor-elements-panel/src/adapters/types';
import { paginationComponentParts } from './editor/panels/design/constants';

const withPaginationPrefixes = (params: Record<string, any>) =>
  withPrefixes(params, paginationComponentParts);

const fontSkinParams = {
  color: {
    type: 'CSS_COLOR',
    defaultValue: cssPropertyToDefaultValueMap.color,
    state: 'regular',
  },
  font: {
    type: 'FONT',
    defaultValue: cssPropertyToDefaultValueMap.font,
    state: 'regular',
  },
  'letter-spacing': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['letter-spacing'],
    state: 'regular',
  },
  'text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    defaultValue: cssPropertyToDefaultValueMap['text-decoration'],
    state: 'regular',
  },
  'text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: cssPropertyToDefaultValueMap['text-shadow'],
    state: 'regular',
  },
  'text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
    state: 'regular',
  },
  'text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: cssPropertyToDefaultValueMap['text-outline'],
    state: 'regular',
  },
  'text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: cssPropertyToDefaultValueMap.none,
    state: 'regular',
  },
};

const borderSkinParams = {
  'border-left': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-left'],
    state: 'regular',
  },
  'border-right': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-right'],
    state: 'regular',
  },
  'border-top': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-top'],
    state: 'regular',
  },
  'border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: cssPropertyToDefaultValueMap['border-bottom'],
    state: 'regular',
  },
};

const cornerSkinParams = {
  'border-top-left-radius': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['border-top-left-radius'],
    state: 'regular',
  },
  'border-top-right-radius': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['border-top-right-radius'],
    state: 'regular',
  },
  'border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['border-bottom-left-radius'],
    state: 'regular',
  },
  'border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: cssPropertyToDefaultValueMap['border-bottom-right-radius'],
    state: 'regular',
  },
};

const iconSkinParams: Record<string, PropDefinition> = {
  'icon-size': {
    type: 'SIZE',
    defaultValue: 'auto',
    state: 'regular',
  },
  'icon-color': {
    type: 'CSS_COLOR',
    defaultValue: cssPropertyToDefaultValueMap.color,
    state: 'regular',
  },
};
const shadowSkinParams: Record<string, PropDefinition> = {
  'box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: cssPropertyToDefaultValueMap['box-shadow'],
    state: 'regular',
  },
};

export const paginationSkinDefinitionMap: Record<string, SkinDefinition> = {
  'wixui.skins.ResponsivePagination': {
    ...withPaginationPrefixes(backgroundSkinParams),
    ...withPaginationPrefixes(fontSkinParams),
    ...withPaginationPrefixes(borderSkinParams),
    ...withPaginationPrefixes(cornerSkinParams),
    ...withPaginationPrefixes(shadowSkinParams),
    ...withPaginationPrefixes(iconSkinParams),
  },
};

export const defaultStyleProperties = generateDefaultStyleProperties(
  paginationSkinDefinitionMap,
);

export default generateSkinDefaults(paginationSkinDefinitionMap);
